var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"400px","height":"400px"},attrs:{"src":_vm.roboticon}}),_vm._v(" "+_vm._s(_vm.output)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }